"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalSearchResultDto = exports.GlobalSearchUserInVenueSectionDto = exports.GlobalSearchUserSectionDto = exports.GlobalSearchVenueSectionDto = exports.GlobalSearchUserInVenueDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const Venue_dto_1 = require("./Venue.dto");
const UserListItem_dto_1 = require("./users/UserListItem.dto");
/**
 * A user enriched with the venue they are associated with, used by the
 * "Checked-in" and "Visit history" sections of the global search.
 */
class GlobalSearchUserInVenueDto extends UserListItem_dto_1.UserListItemDto {}
exports.GlobalSearchUserInVenueDto = GlobalSearchUserInVenueDto;
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Public id of the associated venue (current or last visited).'
}), __metadata("design:type", Object)], GlobalSearchUserInVenueDto.prototype, "venuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Name of the associated venue.'
}), __metadata("design:type", Object)], GlobalSearchUserInVenueDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'ISO timestamp of the association: check-in time for checked-in users, last visit time for history.'
}), __metadata("design:type", Object)], GlobalSearchUserInVenueDto.prototype, "presenceAt", void 0);
class GlobalSearchVenueSectionDto {}
exports.GlobalSearchVenueSectionDto = GlobalSearchVenueSectionDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: Venue_dto_1.VenueDto,
  isArray: true
}), __metadata("design:type", Array)], GlobalSearchVenueSectionDto.prototype, "items", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Total number of matches (may exceed the number of returned items).'
}), __metadata("design:type", Number)], GlobalSearchVenueSectionDto.prototype, "total", void 0);
class GlobalSearchUserSectionDto {}
exports.GlobalSearchUserSectionDto = GlobalSearchUserSectionDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: UserListItem_dto_1.UserListItemDto,
  isArray: true
}), __metadata("design:type", Array)], GlobalSearchUserSectionDto.prototype, "items", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Total number of matches (may exceed the number of returned items).'
}), __metadata("design:type", Number)], GlobalSearchUserSectionDto.prototype, "total", void 0);
class GlobalSearchUserInVenueSectionDto {}
exports.GlobalSearchUserInVenueSectionDto = GlobalSearchUserInVenueSectionDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: GlobalSearchUserInVenueDto,
  isArray: true
}), __metadata("design:type", Array)], GlobalSearchUserInVenueSectionDto.prototype, "items", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Total number of matches (may exceed the number of returned items).'
}), __metadata("design:type", Number)], GlobalSearchUserInVenueSectionDto.prototype, "total", void 0);
/**
 * Result of the cross-system global search. Each section is independent so the
 * UI can render clearly separated result groups.
 */
class GlobalSearchResultDto {}
exports.GlobalSearchResultDto = GlobalSearchResultDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'The query that produced these results.'
}), __metadata("design:type", String)], GlobalSearchResultDto.prototype, "query", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: GlobalSearchVenueSectionDto,
  description: 'Venues matching the query (name / address).'
}), __metadata("design:type", GlobalSearchVenueSectionDto)], GlobalSearchResultDto.prototype, "venues", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: GlobalSearchUserInVenueSectionDto,
  description: 'Matching users currently checked into a venue.'
}), __metadata("design:type", GlobalSearchUserInVenueSectionDto)], GlobalSearchResultDto.prototype, "checkedInUsers", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: GlobalSearchUserInVenueSectionDto,
  description: 'Matching users with venue visit history (most recently visited venue shown).'
}), __metadata("design:type", GlobalSearchUserInVenueSectionDto)], GlobalSearchResultDto.prototype, "visitedUsers", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: GlobalSearchUserSectionDto,
  description: 'All users matching the query.'
}), __metadata("design:type", GlobalSearchUserSectionDto)], GlobalSearchResultDto.prototype, "users", void 0);
//# sourceMappingURL=GlobalSearch.dto.js.map